import * as React from 'react';
import { InputNumber } from 'antd';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetInputText } from '../helper/getWidgetInputText';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { CurrencyInput } from 'client/ui/form/input/CurrencyInput';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';

export interface FormWidgetInputCurrencyViewProps {
  widget: IWidget;
}

export function FormWidgetInputCurrencyView(
  props: FormWidgetInputCurrencyViewProps
) {
  const { widget } = props;

  // Abbiamo un singolo metadato per i campi valuta
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  const [inputProps] = useFormWidgetProps(widget);

  return (
    <FormWidgetItem widget={props.widget} name={name}>
      <CurrencyInput
        name={name}
        placeholder={widget.input?.placeholder}
        style={{ width: '100%' }}
        {...inputProps}
      />
    </FormWidgetItem>
  );
}
